
/* injects from baggage-loader */

'use strict';

import StageBaseController from "../stage-base.controller";

export default class LoginController extends StageBaseController {
	constructor($log, $state, $timeout, Session, Dialog, $scope) {
		'ngInject';

		super($log, $state, Session, Dialog);
		
		this.$timeout = $timeout;
		this.$scope = $scope;
		this.Session = Session;

		this.showName = 0;	

		this.nome = "";
	}

	startGame(){
		this.$timeout(() => {
			this.showName = 1;
		}, 300);
	}

	closeTab(){
		this.Session.destroy();
		this.showName = 0
	}

	clear(){
		this.nome = "";
	}

	showInfo(){
		this.showName = 2
	}

	setName(){
		if((this.nome !== undefined) && (this.nome !== ""))
			this.Session.create(this.nome);
		else
			this.Session.create("Visitante");

		this.$timeout(() => {
			this.$state.go("main");
		}, 300);
	}

}


// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js